export enum AssessmentStatus {
  incomplete = 'INCOMPLETE',
  current = 'CURRENT',
  old = 'OLD',

  // for UI use
  // server doesn't have a status called 'COMPLETE'
  complete = 'COMPLETE'
}
